import { render, staticRenderFns } from "./RecommendSettingComp.vue?vue&type=template&id=3c940602&scoped=true"
import script from "./RecommendSettingComp.vue?vue&type=script&lang=js"
export * from "./RecommendSettingComp.vue?vue&type=script&lang=js"
import style0 from "./RecommendSettingComp.vue?vue&type=style&index=0&id=3c940602&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c940602",
  null
  
)

export default component.exports